import Icon from '../components/Icon.vue'

Icon.register({
  'hot-tub': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M414.2 177.6C415.2 185.9 422 192 430 192H446.1C455.6 192 463.2 183.4 462.1 173.6 457.7 134.5 439.7 99.1 411.9 76.5 394.6 62.3 383.1 39.7 380 14.3 379 6.1 372.2 0 364.2 0H348.1C338.6 0 331 8.6 332.1 18.4 336.4 57.5 354.5 92.9 382.2 115.5 399.6 129.7 411.1 152.3 414.2 177.6zM306.2 177.6C307.2 185.9 314 192 322 192H338.1C347.6 192 355.2 183.4 354.1 173.6 349.7 134.5 331.7 99.1 303.9 76.5 286.6 62.3 275.1 39.7 272 14.3 271 6.1 264.2 0 256.2 0H240.1C230.6 0 223 8.6 224.1 18.4 228.4 57.5 246.5 92.9 274.2 115.5 291.6 129.7 303.1 152.3 306.2 177.6zM480 256H256L145.1 172.8A64-64 0 0 1 106.7 160H64C28.6 160 0 188.6 0 224V448C0 483.4 28.6 512 64 512H448C483.4 512 512 483.4 512 448V288C512 270.3 497.7 256 480 256zM128 440C128 444.4 124.4 448 120 448H104C99.6 448 96 444.4 96 440V328C96 323.6 99.6 320 104 320H120C124.4 320 128 323.6 128 328V440zM224 440C224 444.4 220.4 448 216 448H200C195.6 448 192 444.4 192 440V328C192 323.6 195.6 320 200 320H216C220.4 320 224 323.6 224 328V440zM320 440C320 444.4 316.4 448 312 448H296C291.6 448 288 444.4 288 440V328C288 323.6 291.6 320 296 320H312C316.4 320 320 323.6 320 328V440zM416 440C416 444.4 412.4 448 408 448H392C387.6 448 384 444.4 384 440V328C384 323.6 387.6 320 392 320H408C412.4 320 416 323.6 416 328V440zM64 128C99.3 128 128 99.4 128 64S99.3 0 64 0 0 28.6 0 64 28.6 128 64 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hot-tub.js
// module id = FuCu
// module chunks = 144